<template>
    <template v-if="detail.qrCode">
        <div class="dashboard-table-row table-row-v2 mb-3">
            <div class="dashboard-table-column text-wrap text-center">Для проведения платежа, отсканируйте QR-код в приложении банка</div>
        </div>
        <div class="modal-qr-image modal-qr-mkassa mb-3">
            <img :src="detail.qrCode" :alt="detail.description">
        </div>
    </template>
    <template v-if="detail.deepLink">
        <div class="dashboard-table-row table-row-v2 justify-content-center mb-3">
            <div class="dashboard-table-column text-wrap">Или откройте ссылку для оплаты в MBank:</div>
        </div>
        <a :href="detail.deepLink" class="mbank-button"></a>
    </template>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>